module.exports = __webpack_public_path__ + "img/click.e3cbe900.png";